// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { getProductList } from "@werner/App/Store/Selectors/GeneralSelectors";

export const getLogoImage = (state: ApplicationState) => {
    const logoImage = getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Basic/Logo";
    })?.fields.logoImage;
    return logoImage;
};

export const getMainNavigationWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Header/MainNavigation";
    })?.fields;
};

export const getHeaderSignInWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/HeaderSignIn";
    })?.fields;
};

// </XNG-Changes>
export const getAuthenticatedHeaderSignInWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/HeaderSignIn" && widget.fields.extraLinks.length > 0;
    })?.fields;
};
// </XNG-Changes>

export const getCartLinkWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Common/CartLink";
    })?.fields;
};

export const getLogoImageWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Basic/Logo";
    })?.fields;
};

export const getHeaderActionsWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "HeaderActions/HeaderActions";
    })?.fields;
};

export const getSecondaryNavigationWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Header/SecondaryNavigation";
    })?.fields;
};
export const getHeaderLinkListWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
        return widget.type === "Header/HeaderLinkList";
    })?.fields;
};

export const getProductListViewWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getProductList(state).id).find((widget: WidgetProps) => {
        return widget.type === "ProductList/ProductListViewSelect";
    })?.fields;
};

export const getProductListSearchResultsTipsWidget = (state: ApplicationState) => {
    return getWidgetsByPageId(state, getProductList(state).id).find((widget: WidgetProps) => {
        return widget.type === "Basic/SearchResultTips";
    })?.fields;
};
